import { render } from "./RequestQuotation.vue?vue&type=template&id=fe4f518a"
import script from "./RequestQuotation.vue?vue&type=script&lang=js"
export * from "./RequestQuotation.vue?vue&type=script&lang=js"

import "./RequestQuotation.vue?vue&type=style&index=0&id=fe4f518a&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__